import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { ApiInterceptor, environment } from '@doddly/core';
import { getStorage, provideStorage } from '@angular/fire/storage';
import {
  initializeAppCheck,
  ReCaptchaV3Provider,
  provideAppCheck,
  AppCheck,
} from '@angular/fire/app-check';
import { getApp } from '@angular/fire/app';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },

    provideAnimations(),
    provideRouter(appRoutes),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth()),
    provideStorage(() => getStorage()),
    provideAppCheck(() => {
      if (environment.production) {
        return initializeAppCheck(getApp(), {
          provider: new ReCaptchaV3Provider(environment.recaptchaSiteKey),
          isTokenAutoRefreshEnabled: true,
        });
      }
      return <AppCheck>{};
    }),
  ],
};
